import { FieldPath, FieldValues, UseFormReturn } from "react-hook-form";
import { DatePicker, DatePickerProps } from "@/components/ui/date-picker";
import { FormField } from "@/components/ui/form";
import { FormItemCommonProps, FormItemContent } from "./common";
import { callAll } from "@/lib/utils";

export type FormDatePickerProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
  TContext,
  TTransformedValues extends FieldValues | undefined,
> = {
  form: UseFormReturn<TFieldValues, TContext, TTransformedValues>;
  name: TName;
} & FormItemCommonProps &
  DatePickerProps;

export type FormDatePickerItemCommonProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
  TContext = any,
  TTransformedValues extends FieldValues | undefined = undefined,
> = Omit<
  FormDatePickerProps<TFieldValues, TName, TContext, TTransformedValues>,
  "form" | "name" | "label" | "required" | "form"
> &
  Partial<Pick<FormItemCommonProps, "label">>;

export function FormDatePickerItem<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
  TContext,
  TTransformedValues extends FieldValues | undefined,
>({
  form,
  name,
  label,
  container,
  onChange,
  onBlur,
  ...props
}: FormDatePickerProps<TFieldValues, TName, TContext, TTransformedValues>) {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItemContent
          {...container}
          label={label}
          inline={container?.inline ?? props?.inline}
        >
          <DatePicker
            button={{ className: "h-10" }}
            input={{ className: "h-8" }}
            {...(field as any)}
            {...props}
            onChange={callAll(field.onChange, onChange)}
            onBlur={callAll(field.onBlur, onBlur)}
            placeholder={
              props.inline ? (props.placeholder ?? label) : props.placeholder
            }
          />
        </FormItemContent>
      )}
    />
  );
}
